<template>
  <v-toolbar
    app
    :color="theme.toolbar_bg_color"
    flat
    height="70"
  >
    <v-layout row>
      <v-flex
        xs12
        sm12
        md12
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-layout row align-center>
        <img
          v-if="isHomePage"
          class="icon-img"
          :src="myLogo"
          alt="Home"
        />
        <v-btn
          v-else
          :style="myBackStyle"
          large
          icon
          @click="goback"
        >
          <v-icon large>keyboard_backspace</v-icon>
        </v-btn>
        <v-spacer />
        <profile-icon
          v-if="allowLogin && ($mq === 'sm' || $mq === 'md')"
          :open-drawer-method="openDrawerMethod"
        />
        <v-btn
          icon
          small
          @click="viewCart"
          style="margin-right: 30px;"
        >
          <v-icon
            small
            :color="theme.toolbar_color"
          >fas fa-shopping-cart</v-icon>
          <span
            v-if="cartQty > 0"
            class="ml-2"
            :style="myQtyStyle"
          >{{ cartQty }}</span>
        </v-btn>
        <span :style="myHamburgerStyle">
      <v-btn
        v-if="$mq === 'xs' || $mq === 'sm' || $mq === 'md'"
        icon
        small
        @click="openDrawerMethod"
        class="mr-1"
      >
        <v-icon
          small
          :color="theme.toolbar_color"
        >fas fa-bars</v-icon>
      </v-btn>
    </span>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import ProfileIcon from '~/components/ProfileIcon'

export default {
  components: {
    'profile-icon': ProfileIcon
  },
  props: {
    openDrawerMethod: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'rid', 'gid', 'logo', 'allowLogin'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('cart', [
      'cartQty'
    ]),
    myBackStyle () {
      return {
        color: this.theme.back_btn_color
      }
    },
    myLogo () {
      return this.logo ? this.logo : window.config.sharedPictures + 'logo.png'
    },
    isHomePage () {
      return (this.$route.name === 'welcome' || this.$route.name === 'home' || this.$route.name === 'menu' || this.$route.name === 'register2')
    },
    myQtyStyle () {
      return {
        color: this.theme.toolbar_color
      }
    },
    myHamburgerStyle () {
      if (this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
        return {
          marginLeft: '-10px'
        }
      }
      return {
        marginRight: '-22px'
      }
    }
  },
  methods: {
    goback () {
      switch (this.$route.name) {
        case 'checkout':
          this.$router.push({ name: 'cart' })
          return
        case 'guest_details':
          this.$router.push({ name: 'checkout' })
          return
        case 'order':
        case 'order2':
          this.$router.push({ name: 'orders' })
          return
        case 'mail':
          this.$router.push({ name: 'inbox' })
          return
        case 'bill':
          this.$router.push({ name: 'bills' })
          return
        case 'receipt':
          this.$router.push({ name: 'receipts' })
          return
        case 'reservations':
          this.$router.push({ name: 'reservation_tnc' })
          return
        case 'voucher':
          this.$router.push({ name: 'my_vouchers' })
          return
        case 'cart':
        case 'profile':
        case 'points':
        case 'payment':
        case 'orders':
        case 'reservation_tnc':
        case 'my_vouchers':
        case 'custom_sets':
        case 'addresses':
        case 'receipts':
        case 'bills':
        case 'show_article':
          this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
          return
        default:
          this.$router.push({ name: 'welcome' })
          return
      }
    },
    viewCart () {
      if (this.$route.name !== 'cart') this.$router.push({ name: 'cart' })
    }
  }
}
</script>

<style scoped>
.icon-img {
  height: 44px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ToolBar.vue